import NavBar from '@/components/common/NavBar';
import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router';

const Layout = ({ errorElement }: { errorElement?: React.ReactNode }) => {
	return (
		<Box minH="100vh" bg="bg" color="fg">
			<NavBar />
			<Box as="main">
				<Outlet />
				{errorElement}
			</Box>
		</Box>
	);
};

export default Layout;
